// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2h8CC","main":"App_main__3ZkGI"};